import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { JobStatusText } from '@components/JobStatusText';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { CellContent } from '../../styles/CellContent';
import { StyledLink } from '../../styles/StyledLink';
import { JobTitleCell } from './styles/JobTitleCell';
import { StatusCell } from './styles/StatusCell';
import { TProps } from './types/TProps';

export const InlineJobsTable = ({ data }: TProps) => {
  const { organization } = useAuthContext();
  const colSpan = 9;

  if (!data.checkoutEvents?.length) {
    return (
      <Tr>
        <Td colSpan={colSpan} style={{ height: '100px' }}>
          <div className="flex items-center justify-center" style={{ height: '100px', position: 'relative' }}>
            <div>No data available for this member</div>
          </div>
        </Td>
      </Tr>
    );
  }

  const generateJobLink = (jobId: string, workspaceSlug: string) => {
    return routes.jobDetails.make(organization?.slug ?? '', workspaceSlug ?? '', jobId);
  };

  return (
    <Tr>
      <Td colSpan={colSpan}>
        <TableWrapper>
          <Table>
            <Thead>
              <Tr>
                <Th style={{ width: '30%' }}>Job Title</Th>
                <Th style={{ width: '1%' }}>STT Pages Count</Th>
                <Th style={{ width: '1%' }}>CheckOut Date</Th>
                <Th style={{ width: '1%' }}>CheckIn Date</Th>
                <Th style={{ width: '1%' }}>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.checkoutEvents.map((eventData, index) => (
                <Tr key={index}>
                  <Td>
                    <JobTitleCell>
                      <div>
                        {eventData.Job?.removed ? (
                          eventData.Job?.name || 'Unnamed'
                        ) : (
                          <StyledLink
                            to={generateJobLink(eventData.Job?.id ?? '', eventData.Job?.Workspace?.slug ?? '')}
                          >
                            {eventData.Job?.name || 'Unnamed'}
                          </StyledLink>
                        )}
                      </div>
                      <div style={{ fontSize: '10px', lineHeight: '16px', color: '#B4B9D9' }}>{eventData.Job?.id}</div>
                    </JobTitleCell>
                  </Td>
                  <Td>
                    <CellContent>{eventData.FinalVersion?.Metrics?.pagesCount ?? 0}</CellContent>
                  </Td>
                  <Td>
                    <CellContent>{getAmericanTime(eventData.createdAt)}</CellContent>
                  </Td>
                  <Td>
                    <CellContent>{eventData.finalizedAt ? getAmericanTime(eventData.finalizedAt) : '-'}</CellContent>
                  </Td>
                  <Td>
                    <StatusCell>
                      <JobStatusText status={eventData.jobStatus} />
                    </StatusCell>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      </Td>
    </Tr>
  );
};
